 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import HALF_TITLE from '@/components/half_title'
 import TITLE_PAGE from '@/components/title_page'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import ACKNOWLEDGEMENTS from '@/components/acknowledgements'
 import LIST_OF_ABBREVIATIONS from '@/components/list_of_abbreviations'
 import INTRODUCTION_FACING_MULTIPLE_CHALLENGES from '@/components/introduction_facing_multiple_challenges'
 import A_THE_MAKING_OF_TODAYS_CHINA from '@/components/1_the_making_of_todays_china'
 import A_THE_BROKEN_ECONOMIC_MODEL from '@/components/2_the_broken_economic_model'
 import A_THE_ELUSIVE_KNOWLEDGE_ECONOMY from '@/components/3_the_elusive_knowledge_economy'
 import A_FINANCE from '@/components/4_finance'
 import A_SOCIAL_WELFARE_MISSING_UMBRELLA from '@/components/5_social_welfare_missing_umbrella'
 import A_THE_ENVIRONMENT from '@/components/6_the_environment'
 import A_THREATS_TO_SOCIAL_STABILITY from '@/components/7_threats_to_social_stability'
 import A_THREATS_TO_CIVIL_STABILITY from '@/components/8_threats_to_civil_stability'
 import A_IDENTITY_FUTURE_OF_STATE_AND_PARTY from '@/components/9_identity_future_of_state_and_party'
 import A0_AMERICA_AND_CHINA_COMMON_INTERESTS_MUTUAL_ANTAGONISMS from '@/components/10_america_and_china_common_interests_mutual_antagonisms'
 import A1_GREAT_POWER_RELATIONSHIPS from '@/components/11_great_power_relationships'
 import A2_CENTRAL_ASIA from '@/components/12_central_asia'
 import A3_UNDECLARED_WAR_IN_THE_FOURTH_DIMENSION from '@/components/13_undeclared_war_in_the_fourth_dimension'
 import A4_NERVOUS_NEIGHBOURS from '@/components/14_nervous_neighbours'
 import A5_CHINA_IN_THE_WORLD from '@/components/15_china_in_the_world'
 import A6_OUTCOMES from '@/components/16_outcomes'
 import NOTES from '@/components/notes'
 import BIBLIOGRAPHY from '@/components/bibliography'
 import INDEX from '@/components/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/half_title",
 			"name" : "half_title",
 			"component" : HALF_TITLE
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/acknowledgements",
 			"name" : "acknowledgements",
 			"component" : ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/list_of_abbreviations",
 			"name" : "list_of_abbreviations",
 			"component" : LIST_OF_ABBREVIATIONS
 		},
 		{
 			"path" : "/introduction_facing_multiple_challenges",
 			"name" : "introduction_facing_multiple_challenges",
 			"component" : INTRODUCTION_FACING_MULTIPLE_CHALLENGES
 		},
 		{
 			"path" : "/1_the_making_of_todays_china",
 			"name" : "1_the_making_of_todays_china",
 			"component" : A_THE_MAKING_OF_TODAYS_CHINA
 		},
 		{
 			"path" : "/2_the_broken_economic_model",
 			"name" : "2_the_broken_economic_model",
 			"component" : A_THE_BROKEN_ECONOMIC_MODEL
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js